module.exports = __webpack_public_path__ + "static/img/second_post.c6e4b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/second_post.png
// module id = sFSp
// module chunks = 37